import androidx.compose.runtime.*
import frontend.lib.classList
import frontend.models.Address
import kotlinx.coroutines.GlobalScope
import kotlinx.coroutines.launch
import org.jetbrains.compose.web.attributes.disabled
import org.jetbrains.compose.web.attributes.name
import org.jetbrains.compose.web.attributes.selected
import org.jetbrains.compose.web.dom.*

class ExtAccountSelectAttrsBuilder {
    var onChange: (value: Address?) -> Unit = {}
    var loadAddresses: suspend () -> Unit = {}
    var label: @Composable() () -> Unit = {}
    var options: List<Address> = emptyList()
    var isDisabled = false

    fun onChange(handler: (value: Address?) -> Unit) { onChange = handler }
    fun label(l: @Composable() () -> Unit) { label = l }
    fun disabled() { isDisabled = true }
    fun options(list: List<Address>) { options = list }
}

@Composable
fun AddressSelect(
    id: String,
    selected: Address?,
    attrs: ExtAccountSelectAttrsBuilder.() -> Unit = {}
) {
    val builder = ExtAccountSelectAttrsBuilder()
    attrs.invoke(builder)
    var isLoading by mutableStateOf(false)

    fun loadAddresses() {
        isLoading = true
        GlobalScope.launch {
            builder.loadAddresses()
            isLoading = false
        }
    }

    Div() {
        Label(forId = id, attrs = {
            classes("block", "text-sm", "font-medium", "text-gray-700")
        }) { builder.label() }

        Div(attrs = { classList("max-w-lg flex rounded-md shadow-sm") }) {
            Button(attrs = {
                classList("inline-flex items-center px-3 rounded-l-md border border-r-0 border-gray-300 bg-gray-50 text-gray-500 sm:text-sm")
                onClick { loadAddresses() }
                if (isLoading) disabled()
            }) {
                if (isLoading) Text("...")
                else Text("Refresh")
            }
            Select(attrs = {
                id(id)
                name("select")
                classes(
                    "flex-1",
//                    "mt-1",
                    "block",
                    "w-full",
                    "pl-3",
                    "pr-10",
                    "py-2",
                    "text-base",
                    "border-gray-300",
                    "focus:outline-none",
                    "focus:ring-indigo-500",
                    "focus:border-indigo-500",
                    "sm:text-sm",
                    "rounded-r-md"
                )
                onChange {
                    val code = it.value
                    val acc = builder.options.find { it.address == code }
                    builder.onChange(acc)
                }
            }) {
                builder.options.forEach {
                    val option = it

                    Option(option.address, attrs = {
                        if (selected?.address == option.address) selected()
                    }) { Text(option.name) }
                }
            }
        }
    }
}